import React from "react";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";

export const ToggleSwitch = ({onSwitch, caption, switched}) => {

    const runswitch = () => {
        onSwitch()
    }

    return (
        <div className="switch-container" onClick={runswitch}>
            <div className="switch-caption">{caption}</div>
            <div 
                className={classNames("toggle-slide-box", {"on": switched})}  
            >
                <button 
                    className={classNames("switch-button",{"switched": switched})}
                >
                    <FontAwesomeIcon 
                        icon={!switched ? faPlus : faMinus}
                        className={classNames('norm',{'spin': switched})} 
                    />
                </button>
            </div>
        </div>
    )
}